import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "folder-2" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "Vector" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1.5 4.5C1.5 3.25736 2.50736 2.25 3.75 2.25H6.87868C7.47542 2.25 8.04771 2.48705 8.46967 2.90901L9.09099 3.53033C9.23164 3.67098 9.42241 3.75 9.62132 3.75H14.25C15.4926 3.75 16.5 4.75736 16.5 6V7.15135C16.0587 6.89609 15.5464 6.75 15 6.75H3C2.45357 6.75 1.94126 6.89609 1.5 7.15135V4.5Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1.5 9.75V12.75C1.5 13.9926 2.50736 15 3.75 15H14.25C15.4926 15 16.5 13.9926 16.5 12.75V9.75C16.5 8.92157 15.8284 8.25 15 8.25H3C2.17157 8.25 1.5 8.92157 1.5 9.75Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }